import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { getSupportEmail } from 'helpers';
import { ReferralStatusCode } from '../../types';
import { FcpIconSVGColors, FcpIconSVGSizes, IconNameMap } from 'fc-ui-components';

@Component({
    selector: 'fc-referral-status',
    templateUrl: './referral-status.component.html',
    styleUrls: ['./referral-status.component.less'],
    standalone: false
})
export class SignupReferralStatusComponent implements OnInit {
    iconNameMap = IconNameMap;
    fcpIconSVGSize = FcpIconSVGSizes;
    fcpIconSVGColors = FcpIconSVGColors;
    supportEmail = getSupportEmail();

    text: {
        header: string;
        description: {
            line1?: string;
            line2?: string;
        };
    };

    constructor(
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit(): void {
        const statusCode = this.route.snapshot.paramMap.get('statusCode');

        if (statusCode === ReferralStatusCode.EXPIRED) {
            this.setExpiredReferralText();
        } else {
            this.setInvalidReferralText();
        }
    }

    goToSignup(): void {
        this.router.navigate(['/signup']);
    }

    goToLogin(): void {
        this.router.navigate(['/']);
    }

    private setInvalidReferralText(): void {
        this.text = {
            header: 'SIGNUP.REFERRAL.INVALID_REFERRAL.HEADER',
            description: {
                line1: 'SIGNUP.REFERRAL.INVALID_REFERRAL.DESCRIPTION_LINE1',
                line2: 'SIGNUP.REFERRAL.INVALID_REFERRAL.DESCRIPTION_LINE2'
            }
        };
    }

    private setExpiredReferralText(): void {
        this.text = {
            header: 'SIGNUP.REFERRAL.EXPIRED_REFERRAL.HEADER',
            description: {
                line1: 'SIGNUP.REFERRAL.EXPIRED_REFERRAL.DESCRIPTION_LINE1',
                line2: 'SIGNUP.REFERRAL.EXPIRED_REFERRAL.DESCRIPTION_LINE2'
            }
        };
    }
}
